import React from "react";
import s from "./contactbutton.module.css";

export const ContactButton = () => (
  <div className={s.contactMe}>Contact me</div>
);
